import teacher1 from "../static/teachers/teacher1.jpg";
import teacher3 from "../static/teachers/teacher3.jpg";
import teacher4 from "../static/teachers/teacher4.jpg";
import teacher5 from "../static/teachers/teacher5.jpg";
import teacher6 from "../static/teachers/teacher6.jpg";
import teacher7 from "../static/teachers/teacher7.jpg";
import teacher8 from "../static/teachers/teacher8.jpeg";


export const teachers = [
    {
        id: 1,
        name: "Феоктистова Татьяна Викторовна",
        ageWork: 10,
        special: "Репетитор по русскому языку",
        photo: teacher1,
        description:
            "кандидат педагогических наук, доцент, преподаватель русского языка, в том числе русского языка как иностранного",
    },
    {
        id: 3,
        name: "Лоповок Елена Евгеньевна",
        ageWork: 15,
        special: "Репетитор по математике и информатике",
        photo: teacher3,
        description:
            "преподаватель отделения среднего-профессионального образования КНИТУ-КАИ им.А.Н.Туполева, преподаватель-консультант по математике и информатике",
    },
    {
        id: 4,
        name: "Габдрахманова Полина Леонидовна",
        ageWork: 8,
        special: "Репетитор по русскому языку",
        photo: teacher4,
        description:
            "преподаватель русского языка, в том числе и русского языка как иностранного",
    },
    {
        id: 5,
        name: "Феоктистова Анастасия Андреевна",
        ageWork: 5,
        special: "Репетитор по английскому языку",
        photo: teacher5,
        description:
            "выпускница КФУ, Института международных отношений (Лингвистика: Теория и методика преподавания иностранных языков и культур); диплом с отличием. Уровень владения английским языком - С1. За время учебы в вузе выпустила несколько научных публикаций, а также подготовила собственные методические разработки."
    },
    {
        id: 6,
        name: "Зайнуллин Данияр Ленарович",
        ageWork: 4,
        special: "Репетитор по физике",
        photo: teacher6,
        description:
            "выпускник МГТУ им. Н.Э. Баумана (биотехнические системы и технологии). В 2022 - 2025 годах капитан сборной по олимпиадной физике МГТУ им. Н.Э. Баумана. Обладатель дипломов московских и всероссийских студенческих олимпиад по теоретической физике. До ВУЗа окончил лицей Nº 131 в Казани. Был членом сборной республики Татарстан по олимпиадной физике. Опыт работы со школьниками 4 года, подготовил более 40 учеников. Средний результат ЕГЭ - 76,4 балла."
    },
    {
        id: 7,
        name: "Гопкало Екатерина Александровна",
        ageWork: 9,
        special: "Психолог",
        photo: teacher7,
        description:
            "преподаватель психологии, консультант по профориентации, кандидат психологических наук"
    },

    {
        id: 8,
        name: "Филатов Иван Александрович",
        ageWork: 6,
        special: "Репетитор по обществознанию",
        photo: teacher8,
        description:
            "преподаватель-консультант по обществознанию",
    },
];
